import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './FreelanceInterviewRemarkForm.jsx'

export default createSubmit(name)
